module.exports = __webpack_public_path__ + "static/media/RAINY.538ecca8.png";